<template>
  <div>
    <el-tooltip class="item" effect="dark" placement="bottom">
      <div slot="content">
        {{ $t('common_words.date_or_price_alert') }} <br />
        {{ $t('common_words.price_or_date_alert') }}
      </div>
      <em
        class="fa fa-exclamation-triangle"
        style="color: orange"
        aria-hidden="true"
      ></em>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: 'iconwarning',
};
</script>
